<div class="leading-9">
  <app-footer-router-link
    [route]="Route.PL_Contact"
    text="Kontakt" />

  <app-footer-router-link
    [route]="Route.PL_FAQ"
    fragment="reklamacje"
    text="Reklamacje" />

  <app-footer-router-link
    [route]="Route.PL_FAQ"
    fragment="wysylka"
    text="Wysyłka i płatności" />

  <app-footer-router-link
    [route]="Route.PL_FAQ"
    fragment="subskrypcje-i-pakiety"
    text="Subskrypcje i pakiety" />

  <app-footer-router-link
    [route]="Route.PL_RegulationsOfShop"
    text="Regulamin sklepu" />

  <app-footer-router-link
    [route]="Route.PL_PrivacyPolicy"
    text="Polityka prywatności" />

  <app-footer-router-link
    [route]="Route.PL_RegulationsOfPublishingOpinions"
    text="Regulamin publikacji opinii" />

  <app-footer-router-link
    [route]="Route.PL_FAQ"
    text="FAQ" />

  <app-footer-link
    link="./assets/documents/pdf/formularz_odstapienia_od_umowy_zalacznik_do_umowy_01_2022.pdf"
    text="Formularz odstąpienia od Umowy" />

  <app-footer-router-link
    [route]="Route.PL_Account"
    text="Mój profil" />
</div>
